// Cart utility for localStorage management

const CART_KEY = "swagstore_cart";

// Function to dispatch cart update event
const dispatchCartUpdate = () => {
  window.dispatchEvent(new Event("cartUpdated"));
};

export function getCart() {
  try {
    const cart = localStorage.getItem(CART_KEY);
    return cart ? JSON.parse(cart) : [];
  } catch {
    return [];
  }
}

export function setCart(cart) {
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
  dispatchCartUpdate();
}

export function addToCart(item) {
  const cart = getCart();
  // Check if item (by sku/variant id) already exists
  const idx = cart.findIndex(
    (i) => i.sku === item.sku && i.variant_id === item.variant_id
  );
  if (idx > -1) {
    const isUnlimited =
      cart[idx].limited_stock === false || item.limited_stock === false;
    if (isUnlimited) {
      cart[idx].selected_quantity =
        cart[idx].selected_quantity + item.selected_quantity;
    } else {
      const maxQuantity = cart[idx].max_quantity || item.max_quantity || 10;
      const newQuantity = cart[idx].selected_quantity + item.selected_quantity;
      cart[idx].selected_quantity = Math.min(newQuantity, maxQuantity);
      if (item.max_quantity) {
        cart[idx].max_quantity = item.max_quantity;
      }
    }
  } else {
    cart.push(item);
  }
  setCart(cart);
}

export function updateCartItem(sku, variant_id, quantity) {
  const cart = getCart();
  const idx = cart.findIndex(
    (i) => i.sku === sku && i.variant_id === variant_id
  );
  if (idx > -1) {
    if (cart[idx].limited_stock === false) {
      cart[idx].selected_quantity = Math.max(1, quantity);
    } else {
      const maxQuantity = cart[idx].max_quantity || 10;
      cart[idx].selected_quantity = Math.min(quantity, maxQuantity);
    }
    setCart(cart);
  }
}

export function removeCartItem(sku, variant_id) {
  let cart = getCart();
  cart = cart.filter((i) => !(i.sku === sku && i.variant_id === variant_id));
  setCart(cart);
}

export function clearCart() {
  setCart([]);
}
